import "@nudgebox/ui/fonts.css";
import "@nudgebox/ui/reset.css";
import { ToastProvider, TooltipProvider } from "@nudgebox/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createQueryClient } from "./app/query-client.ts";
import { applyDocumentTheme } from "./app/root-layout.tsx";
import { createAppRouter } from "./app/router.tsx";
import { captureInstallPrompt } from "./lib/install.ts";
import { registerServiceWorker } from "./lib/service-worker.ts";
import { reloadOnStaleChunks } from "./lib/stale-chunks.ts";
import { initTheme } from "./lib/theme.ts";

initTheme();
applyDocumentTheme();
reloadOnStaleChunks();
registerServiceWorker();
captureInstallPrompt();

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root element");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
